import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center h-full w-full gap-16 max-[960px]:overflow-y-auto max-mc:overflow-y-hidden max-[960px]:justify-start max-[960px] px-8" }
const _hoisted_2 = { class: "mt-5 flex flex-col items-center text-center" }
const _hoisted_3 = { class: "rounded-full w-full h-full p-3 flex justify-center items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "text-blue-700 group-data-[state=inactive]:text-muted"
}
const _hoisted_6 = { class: "flex flex-col gap-4 md:w-2/3 max-md:w-full" }
const _hoisted_7 = {
  key: 2,
  class: "flex flex-col grow"
}
const _hoisted_8 = { class: "flex flex-col gap-8 justify-around w-full h-full" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, [
  /*#__PURE__*/_createTextVNode("Seja bem vindo ao "),
  /*#__PURE__*/_createElementVNode("strong", null, "Converza"),
  /*#__PURE__*/_createTextVNode("!")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Sua jornada está apenas começando, em alguns instantes você será redireciado para a página principal.", -1)

import { watch } from 'vue';
import { Check } from 'lucide-vue-next';
import { set } from '@vueuse/core';
import { Stepper, StepperItem, StepperSeparator, StepperTitle, StepperTrigger } from '@/components/ui/stepper';
import { Button } from '@/components/ui/button';
import LeadForm from './LeadForm.vue';
import PartnerForm from './PartnerForm.vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterComponent',
  props: {
    "modelValue": {
  default: 1,
  required: false,
  type: Number
},
    "modelModifiers": {},
  },
  emits: /*#__PURE__*/_mergeModels(['TOGGLE_REGISTRATION'], ["update:modelValue"]),
  setup(__props) {



const stepIndex = _useModel(__props, "modelValue");
const steps = [
  {
    step: 1,
    title: 'Seus dados',
  },
  {
    step: 2,
    title: 'Personalização',
  },
  {
    step: 3,
    title: 'Conclusão',
  },
];

function goNext() {
  set(stepIndex, stepIndex.value + 1);
}

const router = useRouter();

const redirectToConverza = async () => {
  return await router.push({ path: '/dashboard' });
};

watch(stepIndex, async (newValue) => {
  if (newValue === 3) {
    setTimeout(async () => {
      await redirectToConverza();
    }, 4000);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Stepper), {
      modelValue: stepIndex.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stepIndex).value = $event)),
      class: "flex w-full items-start gap-2"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step) => {
          return _createVNode(_unref(StepperItem), {
            key: step.step,
            class: "relative flex w-full flex-col items-center justify-center",
            step: step.step
          }, {
            default: _withCtx(({ state }) => [
              (step.step !== steps[steps.length - 1].step)
                ? (_openBlock(), _createBlock(_unref(StepperSeparator), {
                    key: 0,
                    class: "absolute left-[calc(50%+20px)] right-[calc(-50%+10px)] top-[69px] block h-0.5 shrink-0 rounded-full bg-muted group-data-[state=completed]:bg-blue-700"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(StepperTitle), {
                  class: _normalizeClass([[state === 'active' && 'text-primary'], "text-sm font-semibold transition lg:text-base"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(step.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _createVNode(_unref(StepperTrigger), { "as-child": "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    variant: "outline",
                    size: "icon",
                    class: "z-10 rounded-full shrink-0 bg-white group-data-[state=completed]:bg-blue-700 border-2 group-data-[state=inactive]:border-muted group-data-[state=active]:border-blue-700 group-data-[state=completed]:border-white override-opacity-to-100",
                    onClick: _cache[0] || (_cache[0] = (event) => { event.preventDefault(); }),
                    onSubmit: _cache[1] || (_cache[1] = (event) => { event.preventDefault(); })
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        (state === 'completed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_unref(Check), { class: "size-5 text-white" })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(step.step), 1))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["step"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_6, [
      (stepIndex.value === 1)
        ? (_openBlock(), _createBlock(LeadForm, {
            key: 0,
            onNextStep: goNext,
            onTOGGLE_REGISTRATION: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('TOGGLE_REGISTRATION')))
          }))
        : (stepIndex.value === 2)
          ? (_openBlock(), _createBlock(PartnerForm, {
              key: 1,
              onNextStep: goNext,
              onTOGGLE_REGISTRATION: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('TOGGLE_REGISTRATION')))
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_unref(Button), {
                  class: "w-full text-white rounded-full",
                  variant: "default",
                  type: "submit",
                  size: "sm",
                  onClick: _cache[5] || (_cache[5] = async () => await redirectToConverza())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ir para o Converza ")
                  ]),
                  _: 1
                })
              ])
            ]))
    ])
  ]))
}
}

})